import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';

import swal from 'sweetalert2';

import {AuthService} from '../services/auth.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css']
})
export class LoginComponent implements OnInit {

  user_id : string;
  user_pwd : string;
  previousUrl : string;
  fgtpwd;
  setpwd;
  otp_success_msg;

  otp;
  new_pwd;
  re_new_pwd;

  show_err;
  err_msg;

  constructor(private router:Router,public authService : AuthService) { 

    this.fgtpwd = false;
    this.setpwd = false;
    this.otp_success_msg = "";   
    this.err_msg = "";
  }

  ngOnInit() {
    if(this.authService.loggedIn()){
      this.router.navigate(['./dashboard']);
    }
    this.fgtpwd = false;
    this.setpwd = false;
    this.show_err = false;
    this.otp_success_msg = "";
    this.err_msg = "";
  }

  processLogin(){
    let user_id = this.user_id;
    let password = this.user_pwd;
    if(!user_id || (user_id==undefined) || user_id == ""){
      swal("Oops!!","User id is required","error");
      return;
    }

    if(!password || (password==undefined) || password == ""){
      swal("Oops!!","Password is required","error");
      return;
    }
    this.authService.login({user_id,password}).subscribe((res:any) =>{
      if(res.error){
        swal("Ooops !!",res.message,"error");        
        return;
      }
      this.authService.storeUserData(res.token, res.user);

      //swal("Success",res.message,"success");
      //this.router.navigate(["./dashboard"]);
      setTimeout(() =>{          
        if(this.previousUrl){            
          this.router.navigate([this.previousUrl]);
        }
        else{                    
           this.router.navigate(['./dashboard']);
        }
      },500)
    })   
    return;    
  }

  fgtPwdPanel(){
    this.fgtpwd = true;
  }

  loginPanel(){
    this.fgtpwd = false;
  }

  getOTP(){
    let user_id = this.user_id;
    if(user_id && user_id != undefined && user_id !=""){
      this.authService.sendOTP({user_id}).subscribe((res:any) =>{
        
        if(res.error){
          swal("Oops!!",res.message,"error")
          return;
        }else{
          this.otp_success_msg = res.message;       
          this.setpwd = true; 
        }

        
      })
      return;
    }

    swal("Oops!!","User ID is required","error");

    return;
  }

  processForgotPaswd(){
    let user_id = this.user_id;
    let otp = this.otp;
    let new_pwd = this.new_pwd;
    let re_new_pwd = this.re_new_pwd;
    
    let __validate = true;
    let err_msg = "";

    if(!user_id || (user_id && (user_id == undefined || user_id ==""))){
      __validate = false;
      err_msg = "Please enter user id";
    }

    if(!otp || (otp && (otp == undefined || otp ==""))){
      __validate = false;
      err_msg = "Please enter otp";
    }

    if(!new_pwd || (new_pwd && (new_pwd == undefined || new_pwd ==""))){
      __validate = false;
      err_msg = "Please enter new password";
    }

    if(!re_new_pwd || (re_new_pwd && (re_new_pwd == undefined || re_new_pwd ==""))){
      __validate = false;
      err_msg = "Please enter re-password";
    }

    if(new_pwd !=re_new_pwd){
      __validate = false;      
      err_msg = "Password mismatch";
    }


    if(!__validate){
      this.show_err = true;
      this.err_msg = err_msg;
    }

    this.show_err = false;
    this.err_msg = "";

    let req_args = {
      user_id : this.user_id,
      password : new_pwd,
      otp
    }

    if(user_id && user_id != undefined && user_id !=""){
      this.authService.resetPwd(req_args).subscribe((res:any) =>{
        
        if(res.error){
          //swal("Oops!!",res.message,"error")
          this.show_err = true;
          this.err_msg = res.message;
          return;
        }
        
        swal("Success",res.message,"success");
        
        let self = this;

        setTimeout(function(){
          self.fgtpwd = false;
          self.user_id = "";
          self.otp = "";
          self.new_pwd = "";
          self.re_new_pwd = "";
        },20);    

      })
    }
    return;
  }

}



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/login/login.component.ts